import { FC } from 'react';
import { v4 as uuid } from 'uuid';

import './LogisticsServicesLoaderCards.scss';
interface ILogisticsServicesLoaderCards {
  numberCards: number;
  orientation: 'vertical' | 'horizontal';
}

const LogisticsServicesLoaderCards: FC<ILogisticsServicesLoaderCards> = ({
  numberCards,
  orientation
}: ILogisticsServicesLoaderCards) => {
  const list = Array(numberCards).fill('.');

  return (
    <>
      {list &&
        list.length > 0 &&
        list.map(item => {
          return (
            <div
              className="animationLoader"
              key={`loader-card-SL-${uuid()}`}
              id={
                orientation === 'vertical'
                  ? 'logisticsServicesLoaderCardsVertical'
                  : 'logisticsServicesLoaderCardsHorizontal'
              }
            />
          );
        })}
    </>
  );
};

export default LogisticsServicesLoaderCards;
